import _ from 'lodash';

export default class BOClaimExtension {
    constructor(claim) {
        Object.defineProperty(this, 'claim', {
            enumerable: false,
            value: claim
        });

        this.incidentReport = this.claim.lobs.businessOwners
        && _.isBoolean(this.claim.lobs.businessOwners.incidentReport)
            ? this.claim.lobs.businessOwners.incidentReport
            : false;
        this.dateOfNotice = this.claim.lobs.businessOwners
        && this.claim.lobs.businessOwners.dateOfNotice
            ? this.claim.lobs.businessOwners.dateOfNotice
            : null;
        this.fixedPropertyIncidents = this.claim.lobs.businessOwners
        && this.claim.lobs.businessOwners.fixedPropertyIncidents
            ? this.claim.lobs.businessOwners.fixedPropertyIncidents
            : null;
    }
}
